<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ORIM-Dedication" style="margin-top:3em;">For my grandsons in the future Laurence and Thomas</p>
<p class="ORIM-Dedication">(Thomas who was the first person to read this discourse)</p>
<p class="ORIM-Dedication">And to Jason and Max and Ben</p>
<p class="ORIM-Dedication">and of course Archie with my love. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FinchesofMars_1P2.vue?4c5e9302